/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as n}from"../../chunks/vec3f64.js";import r from"../Point.js";import{projectBuffer as o}from"./projectBuffer.js";function t(n,t,f){if(null==t||null==f)return null;const l=new r({spatialReference:f});return o(n,t,0,e,f,0,1)?(l.x=e[0],l.y=e[1],l.z=e[2],l):null}const e=n();export{t as projectVectorToPoint};
